// src/utils/api.js

/**
 * Utility function to simulate API calls for different content types.
 * In a real application, this would make actual fetch requests to a backend.
 * @param {string} type - The type of data to fetch ('paintings', 'maps', 'books').
 * @returns {Promise<Array>} A promise that resolves with an array of data objects.
*/
export const fetchData = async (type) => {
  // Simulate network delay
  // await new Promise(resolve => setTimeout(resolve, 1000));

  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/data?url=${type}`);
  const data = await response.json();
  return data;
};

export const fetchMenu = async () => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/data/menu`);
  const data = await response.json();
  return data;
};

export const fetchRandomImages = async (count) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/data/random?count=${count}`);
  const data = await response.json();
  console.log(`Fetched random images: ${data}`);
  
  return data;
}

export const fetchText = async (url) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/data/text?url=${encodeURIComponent(url)}`);
  if (!response.ok) {
    throw new Error('Failed to fetch text');
  }
  const data = await response.text();
  return data;
};

export const sendEmail = async (name, email, message) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/email`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ name, email, message }),
  });

  if (!response.ok) {
    throw new Error('Failed to send email');
  }

  const data = await response.json();
  return data;
};
